import { render, staticRenderFns } from "./setGajiKup.vue?vue&type=template&id=1b0a0536&"
import script from "./setGajiKup.vue?vue&type=script&lang=js&"
export * from "./setGajiKup.vue?vue&type=script&lang=js&"
import style0 from "./setGajiKup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports